<!-- 背景设置 -->
<template>
    <div>
        <div class="card"><div class="title">背景设置</div></div>
        <div class="card mb-0">
            <Form :model="backgroundData" label-position="right" :label-width="80">
                <FormItem label="背景颜色"><ColorPicker v-model="backgroundData.content.bg_color"/></FormItem>
                <FormItem label="背景图">
                    <i-switch v-model="backgroundData.content.bgValue" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBgValue">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem v-if="backgroundData.content.bgValue" label="上传背景">
                    <div class="form-upload" @click="openModal">
                        <img class="form-img" v-if="backgroundData.content.imgs.picview" :src="backgroundData.content.imgs.picview"/>
                        <Icon v-else type="md-add" size="30" color="#ccc"/>
                    </div>
                </FormItem>
            </Form>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal" :select="select" :select_type="select_type" @change="costPlannedAmountChange"></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        backgroundData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
        };
    },
    mounted() {
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.backgroundData.content.imgs.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.backgroundData.content.imgs.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        changeBgValue(e) {
            this.backgroundData.content.bgValue = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form-img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
    border: 1px solid #fff;
}
</style>